import React from "react";
import { Spin, Row, Col, Radio } from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "./Filters";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import KpiCard from "./KpiCard";
import ChartPanel from "./ChartPanel";
import GraficoAntiguedad from "./GraficoAntiguedad";
import cuentasCobrarService from '../../../service/tesoreria/cuentasCobrar';

import { buildDashboardData, formatCurrency } from "./utils";
import "./styles.css";

// Por defecto: ultimos 3 meses (global descuenta 3 meses con el flag true).
function filtroInicial() {
    return {
        anioInicio: global.fetchCurrentYear(true),
        mesInicio: global.fetchCurrentMonth(true),
        anioFin: global.fetchCurrentYear(),
        mesFin: global.fetchCurrentMonth(),
        flagNotaVenta: false,
    };
}

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            moneda: "PEN",
            anios: anioMock.values,
            meses: mesMock.values,
            filter: filtroInicial(),
            dashboard: buildDashboardData(null),
        };
    }

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeMoneda = (e) => {
        this.setState({ moneda: e.target.value });
    };

    handleClearFilters = () => {
        const filter = filtroInicial();
        this.setState({ filter, moneda: "PEN" });
        this.handleGenerateReport(filter);
    };

    handleGenerateReport = async (filter) => {
        this.setState({
            loading: true,
        });
        const response = await cuentasCobrarService.dashboardDeuda(filter);
        this.setState({
            dashboard: buildDashboardData(response),
            loading: false,
        });
    };

    async componentDidMount() {
        await this.handleGenerateReport(this.state.filter);
    }

    renderKpi(kpi, props) {
        const { moneda } = this.state;
        const clave = moneda === "USD" ? "usd" : "pen";
        return <KpiCard {...props} value={formatCurrency(kpi[clave], moneda)} />;
    }

    render() {
        const { moneda } = this.state;
        const { kpis, antiguedadCobrar, antiguedadPagar } = this.state.dashboard;
        const clave = moneda === "USD" ? "usd" : "pen";

        return (
            <div>
                <Header
                    title="Dashboard de Cuentas por Cobrar y por Pagar"
                    onClearFilters={this.handleClearFilters}
                    onSearch={() => this.handleGenerateReport(this.state.filter)}
                />
                <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
                <div className="deu-moneda-toggle">
                    <Radio.Group value={moneda} onChange={this.handleChangeMoneda} buttonStyle="solid">
                        <Radio.Button value="PEN">S/ Soles</Radio.Button>
                        <Radio.Button value="USD">US$ Dólares</Radio.Button>
                    </Radio.Group>
                </div>
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <div className="deu-kpi-row">
                        {this.renderKpi(kpis.totalCobrar, {
                            icon: "team",
                            iconColor: "#2563eb",
                            iconBackground: "#e8f0fe",
                            label: "Total Cuentas por Cobrar",
                        })}
                        {this.renderKpi(kpis.vencidoCobrar, {
                            icon: "team",
                            iconColor: "#16a34a",
                            iconBackground: "#e3f6ea",
                            label: "Clientes Vencidos",
                        })}
                        {this.renderKpi(kpis.totalPagar, {
                            icon: "file-text",
                            iconColor: "#7c3aed",
                            iconBackground: "#efe7fd",
                            label: "Total Cuentas por Pagar",
                        })}
                        {this.renderKpi(kpis.vencidoPagar, {
                            icon: "file-exclamation",
                            iconColor: "#ea580c",
                            iconBackground: "#fff1e6",
                            label: "Proveedores Vencidos",
                        })}
                    </div>

                    <Row gutter={16}>
                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Cuentas por Cobrar por Antigüedad">
                                <GraficoAntiguedad
                                    datos={antiguedadCobrar[clave].datos}
                                    total={antiguedadCobrar[clave].total}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>
                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Cuentas por Pagar por Antigüedad">
                                <GraficoAntiguedad
                                    datos={antiguedadPagar[clave].datos}
                                    total={antiguedadPagar[clave].total}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>
                    </Row>
                </Spin>
            </div>
        );
    }
}
